import { htmlToStressPlainText, plainTextToStressHtml } from './stressRichText';

export const TIPOS_STRESS = {
  STRESS_FISIOLOGICO: 'Stress Fisiológico',
  STRESS_FARMACOLOGICO: 'Stress Farmacológico',
};

const TABELA_MEDIDAS_VE_HTML = [
  '<table>',
  '<tbody>',
  '<tr>',
  '<td>Septo..............................: --- (cm)</td>',
  '<td>Via de Saída do VE........: ---</td>',
  '</tr>',
  '<tr>',
  '<td>PP VE..............................: --- (cm)</td>',
  '<td>Fração de Encurtamento....: ---</td>',
  '</tr>',
  '<tr>',
  '<td>Relação Septo/PP VE................: ---</td>',
  '<td>Fração de Ejeção..........: ---</td>',
  '</tr>',
  '<tr>',
  '<td>Diâmetro Diastólico................: --- (cm)</td>',
  '<td>Massa do VE...............: --- (g/m²)</td>',
  '</tr>',
  '<tr>',
  '<td>Diâmetro Sistólico.................: --- (cm)</td>',
  '<td></td>',
  '</tr>',
  '</tbody>',
  '</table>',
].join('');

const BLOCO_CAVIDADES_E_VALVAS_HTML = [
  '<p><strong>Avaliação da Função Diastólica do VE:</strong></p>',
  '<p><br></p>',
  '<p><strong>Comentários:</strong></p>',
  '<p>Relaxamento Ventricular Esquerdo dentro da normalidade</p>',
  '<p><br></p>',
  '<p><strong>Átrio Esquerdo:</strong></p>',
  '<p>Diâmetro do AE: --- (cm)</p>',
  '<p>Diâmetros normais</p>',
  '<p><br></p>',
  '<p><strong>Átrio Direito:</strong></p>',
  '<p>Diâmetro do AD: --- (cm)</p>',
  '<p>Diâmetros normais</p>',
  '<p><br></p>',
  '<p><strong>Ventrículo Direito:</strong></p>',
  '<p>Diâmetro do VD: --- (cm)</p>',
  '<p>Diâmetros normais</p>',
  '<p><br></p>',
  '<p><strong>Aorta:</strong></p>',
  '<p>Diâmetro da Aorta: --- (cm)</p>',
  '<p>Diâmetros normais</p>',
  '<p><br></p>',
  '<p><strong>Valva Mitral:</strong></p>',
  '<p>Abertura, mobilidade e espessura normais</p>',
  '<p>Fluxo normal na região subvalvar</p>',
  '<p><br></p>',
  '<p><strong>Valva Aórtica:</strong></p>',
  '<p>Abertura, mobilidade e espessura normais</p>',
  '<p>Fluxo normal na região subvalvar</p>',
  '<p><br></p>',
  '<p><strong>Valva Tricúspide:</strong></p>',
  '<p>Abertura, mobilidade e espessuras normais</p>',
  '<p>Fluxo normal na região subvalvar</p>',
  '<p><br></p>',
  '<p><strong>Valva Pulmonar:</strong></p>',
  '<p>Abertura, mobilidade e espessuras normais</p>',
  '<p>Fluxo normal na região subvalvar</p>',
  '<p><br></p>',
  '<p><strong>Pericárdio:</strong></p>',
  '<p>Aspecto normal</p>',
].join('');

export const STRESS_HTML_TEMPLATES = {
  [TIPOS_STRESS.STRESS_FISIOLOGICO]: [
    '<p><strong>Avaliação da Função Sistólica do Ventrículo Esquerdo em repouso:</strong></p>',
    TABELA_MEDIDAS_VE_HTML,
    '<p><br></p>',
    '<p><strong>Comentários:</strong></p>',
    '<p>Diâmetros e espessuras miocárdicas normais</p>',
    '<p>Padrão contrátil normal</p>',
    '<p><br></p>',
    BLOCO_CAVIDADES_E_VALVAS_HTML,
    '<p><br></p>',
    '<p><strong>Stress Fisiológico:</strong></p>',
    '<p>Paciente andou por --- minutos no protocolo de Bruce Modificado, com VO2 máximo = --- ml/Kg/min e Duplo produto = ---</p>',
    '<p>Atingiu FC = --- bpm (FC máx = --- bpm e FC submáx = --- bpm).</p>',
    '<p>PA repouso = --- mmHg e PA pico do esforço = --- mmHg.</p>',
    '<p>Comportamento normal da pressão arterial.</p>',
    '<p>Análise eletrocardiográfica apresentando resposta sem critério de isquemia do miocárdio no esforço realizado.</p>',
    '<p>Ausência de arritmias.</p>',
    '<p>Paciente não apresentou sintomas.</p>',
    '<p><br></p>',
    '<p><strong>Avaliação do Ventrículo Esquerdo:</strong> aumento da contratilidade miocárdica e da FE, sugerindo boa reserva coronariana.</p>',
    '<p>No repouso houve regressão para os padrões basais.</p>',
    '<p><br></p>',
    '<p><strong>CONCLUSÃO:</strong></p>',
    '<p>Negativo para isquemia miocárdica</p>',
  ].join(''),

  [TIPOS_STRESS.STRESS_FARMACOLOGICO]: [
    '<p><strong>Avaliação da Função Sistólica do Ventrículo Esquerdo em repouso:</strong></p>',
    TABELA_MEDIDAS_VE_HTML,
    '<p><br></p>',
    '<p><strong>Comentários:</strong></p>',
    '<p>Diâmetros normais</p>',
    '<p>Padrão contrátil normal</p>',
    '<p><br></p>',
    BLOCO_CAVIDADES_E_VALVAS_HTML,
    '<p><br></p>',
    '<p><strong>Stress Farmacológico:</strong></p>',
    '<p>Realizado infusão endovenosa contínua de Dobutamina (dose máx = --- ug/Kg) e administração de Atropina (--- mg) e Brevibloc --- ml após.</p>',
    '<p>Atingiu FC = --- bpm (FCmáx = --- e FCsubmáx = ---).</p>',
    '<p>PA repouso = --- mmHg e PA pico do esforço = --- mmHg.</p>',
    '<p>Comportamento normal da pressão arterial.</p>',
    '<p>Análise eletrocardiográfica apresentando resposta negativa para isquemia.</p>',
    '<p>Ausência de arritmias. Paciente não apresentou sintomas.</p>',
    '<p><br></p>',
    '<p><strong>Avaliação do Ventrículo Esquerdo:</strong> aumento da contratilidade miocárdica e da FE, sugerindo boa reserva coronariana. No repouso houve regressão para os padrões basais.</p>',
    '<p><br></p>',
    '<p><strong>CONCLUSÃO:</strong></p>',
    '<p>Negativo para isquemia miocárdica</p>',
  ].join(''),
};

export const STRESS_TEMPLATES = {
  [TIPOS_STRESS.STRESS_FISIOLOGICO]: htmlToStressPlainText(
    STRESS_HTML_TEMPLATES[TIPOS_STRESS.STRESS_FISIOLOGICO]
  ),
  [TIPOS_STRESS.STRESS_FARMACOLOGICO]: htmlToStressPlainText(
    STRESS_HTML_TEMPLATES[TIPOS_STRESS.STRESS_FARMACOLOGICO]
  ),
};

export const getTemplate = (tipo) => {
  return STRESS_TEMPLATES[tipo] || '';
};

export const getTemplateHtml = (textoOuTipo) => {
  if (STRESS_HTML_TEMPLATES[textoOuTipo]) {
    return STRESS_HTML_TEMPLATES[textoOuTipo];
  }
  return plainTextToStressHtml(textoOuTipo);
};

export default STRESS_TEMPLATES;
